import axios from "axios";

export const patientQuestionRequest = async (params: {
    patient: any;
    submitCount: number;
    patientQuestion: any;
    zipCode: number;
    lastExam: string;
    lastOfficeVisit: string;
    id_token: string;
}): Promise<void> => {
  const { patient, submitCount, patientQuestion, zipCode, lastExam, lastOfficeVisit, id_token } = params;
  const { data } = await axios.post("/api/v2/questionaire_responses", {
        "questionaire_responses": {
            "attempts": submitCount,
            "encodedZip": patientQuestion.ZipCode,
            "encodedLastExamDate": patientQuestion.LastExamDate,
            "encodedLastExamAdd": patientQuestion.LastExamAdd,
            "userZip": zipCode,
            "userLastExamAdd": lastOfficeVisit,
            "userLastExamDate": lastExam,
            ciam_token: id_token,
            patient: patient
        }
    },{
    headers: {
        'Content-Type': 'application/json'
    }
});

  return data;
};
